module.exports = __webpack_public_path__ + "img/collA_s.41bd58c3.png";